import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg';

import { StyledCustomSearch } from './styles';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface ICustomSearchProps {
  children?: React.ReactNode;
  onChange: (value: string) => void;
}

export const CustomSearch = ({ children, onChange }: ICustomSearchProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');

  const changeInputHandler =
    (instant?: boolean): React.ChangeEventHandler<HTMLInputElement> =>
    (event) => {
      const { value } = event.target;
      setInputValue(value);
      if (instant && onChange) onChange(value);
    };

  return (
    <StyledCustomSearch>
      <input
        className="search-input"
        placeholder={t('adminPage.search.placeholder')}
        value={inputValue}
        onChange={changeInputHandler(true)}
      />
      <button className="search-input-button">
        <SearchIcon className="search-input-button__icon" />
      </button>
    </StyledCustomSearch>
  );
};
